module.exports = __webpack_public_path__ + "components/zebra-list/static/stopwatch-8eafd80ecb8656bb7589e07fdf4821a5.svg";